export const PROMO_BAR_TEMPLATES = {
  classic: {
    id: 'classic',
    label: 'Classic — bleu marine',
    height_px: 44,
    background: 'linear-gradient(90deg, #0B1F3F 0%, #1e3a5f 100%)',
    border_css: 'none',
    text_color: '#FFFFFF',
    accent_color: '#38BDF8',
    font_size_px: 14,
  },
  urgent: {
    id: 'urgent',
    label: 'Urgent — rouge / orange',
    height_px: 48,
    background: 'linear-gradient(90deg, #b91c1c 0%, #ea580c 100%)',
    border_css: '2px solid #fecaca',
    text_color: '#FFFFFF',
    accent_color: '#FEF08A',
    font_size_px: 15,
  },
  elegant: {
    id: 'elegant',
    label: 'Elegant — or & noir',
    height_px: 46,
    background: 'linear-gradient(90deg, #1c1917 0%, #292524 100%)',
    border_css: '1px solid #d4af37',
    text_color: '#fafaf9',
    accent_color: '#d4af37',
    font_size_px: 14,
  },
};

export function resolvePromoBarStyles(config) {
  const templateKey = config?.template === 'custom' ? 'custom' : (config?.template || 'classic');
  const preset = PROMO_BAR_TEMPLATES[templateKey] || PROMO_BAR_TEMPLATES.classic;
  const custom = config?.custom || {};

  if (templateKey === 'custom') {
    return {
      height_px: Number(custom.height_px) || 44,
      background: custom.background || '#0B1F3F',
      border_css: custom.border_css || 'none',
      text_color: custom.text_color || '#FFFFFF',
      accent_color: custom.accent_color || '#38BDF8',
      font_size_px: Number(custom.font_size_px) || 14,
    };
  }

  return {
    height_px: preset.height_px,
    background: preset.background,
    border_css: preset.border_css,
    text_color: preset.text_color,
    accent_color: preset.accent_color,
    font_size_px: preset.font_size_px,
  };
}

export function formatPromoMessage(template, vars) {
  if (!template) return '';
  return String(template)
    .replace(/\{code\}/g, vars.code || '')
    .replace(/\{percent\}/g, String(vars.percent ?? ''))
    .replace(/\{discount\}/g, vars.discount ? `-${vars.discount}%` : '');
}
